import Overview from './overview.vue';
import MobOverview from '@/rebuild/materials/shared/us_announcement/mobile/MobOverview.vue';
import MobFull from '@/rebuild/materials/shared/us_announcement/mobile/MobFull.vue';

export const componentMap = {
	overview: Overview,
	'mob-overview': MobOverview,
	'mob-full': MobFull
}; 